import {
  AssetDTO,
  BaseEntityDTO,
  IAssetDTO,
  IBaseEntityDTO,
  IReleaseDTO,
  ITeamCriteriaDTO,
  ReleaseDTO,
} from './';
import { TeamCriteriaDTO } from './team.criteria.dto';

export interface IContestDTO extends IBaseEntityDTO {
  name: string;
  video?: IAssetDTO;
  teamCriteria?: ITeamCriteriaDTO;
  releases: IReleaseDTO[];
}

export class ContestDTO extends BaseEntityDTO implements IContestDTO {
  name: string;
  video?: IAssetDTO;
  teamCriteria?: ITeamCriteriaDTO;
  releases: IReleaseDTO[];

  constructor(data?: Partial<ContestDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.name = data?.name ?? '';
    this.video = data?.video ? new AssetDTO(data.video) : undefined;
    this.teamCriteria = data?.teamCriteria ? new TeamCriteriaDTO(data.teamCriteria) : undefined;
    this.releases = data?.releases ? data.releases.map((release) => new ReleaseDTO(release)) : [];
  }
}
